import { RichTextRenderer } from "components/RichTextRenderer";
import { find, isUndefined } from "lodash";
import React from "react";
import { FindingSummary } from "types/api/findingSummary";
import { ArmorcodeCustomField } from "types/tenantConfig";

import { ACTableColumnType } from "ac-components/ACTable/ACTable";

export default function useCustomFieldsColumns(
  customFieldColumns: ArmorcodeCustomField[] | undefined,
) {
  const customColumns: ACTableColumnType<FindingSummary>[] = [];
  if (!isUndefined(customFieldColumns)) {
    customFieldColumns.forEach((col) => {
      customColumns.push({
        title: col.label,
        dataIndex: col.id,
        key: col.id,
        render: (value, record) => {
          const displayText = find(
            record.customFields,
            (customField) => customField.fieldId === col.id,
          )?.fieldValue;
          return <RichTextRenderer content={displayText} />;
        },
        width: 150,
      });
    });
  }
  return customColumns;
}
